import styled from 'styled-components';

export const QuestionForm = styled.div`
  padding: 12px;
  background: ${({isEmpty})=>isEmpty?'rgb(255, 244, 244)':'#fff'};
  margin: 12px 0;
  border: 1px solid ${({isEmpty})=>isEmpty?'rgb(197, 24, 24)':'#fff'};
  border-radius: 4px;
  .radio label, 
  .checkbox label {
    position: relative;
    font-size: 16px;
    padding: 0;
    cursor: auto;
  }
  .radio label span, 
  .checkbox label span {
    display: initial;
    position: relative;
    left: 10px;
    top: 2px;
    transition-duration: 0.2s;
    cursor: auto;
  }
  .form-inline .radio input[type=radio], 
  .form-inline .checkbox input[type=checkbox] {
    opacity: 1;
    height: 16px;
    width: 16px;
    overflow: hidden;
    vertical-align: middle;
    position: relative;
  }
    .form-control {
        word-wrap: break-word;
        hyphens: auto;
        white-space: pre-line;
        resize: none;
        color: rgba(0, 0, 0, 0.65);
        background-color: #fff;
        background-image: none;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        transition: all .3s;
        padding: 6px;
        width: 100%;
        margin: 16px 0;
        outline: none;
        &:hover {
          border-color: #49a9ee;
          box-shadow: 0 0 15px rgba(16, 142, 233, 0.25);
        }
        &:active {
          border-color: #49a9ee;
          box-shadow: 0 0 15px rgba(16, 142, 233, 0.25);
        }
        &:not(input),
        &:not(textarea),
        &:not(select) {
            height: auto;
            min-height: 104px;
            padding-bottom: 6px;
        }
    }
    input[type="radio"], input[type="checkbox"] {
      cursor: pointer;
    }
    .btn-primary {
      color: #fff;
      background-color: #108ee9;
      border: 1px solid #108ee9;
      padding: 0 15px;
      font-size: 12px;
      border-radius: 4px;
      font-weight: 700;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      &:hover{
        background-color: #49a9ee;
      }
    }
    .alert{
      color: red;
    }
    .alert-danger {
        background-color: #ffefee;
        padding: 0 4px;
    }
    h3{
      font-size: 24px;
      margin: 12px 0;
      color: #5a5a5a;
    }
    h5 {
        font-size: 18px;
        font-weight: 700;
    }
    #sq_page{
      padding-bottom: 12px;
      margin-bottom: 12px;
      border-bottom: 2px solid #ececec;
    }
    #sq_page h5{
      padding-top: 12px;
      margin: 12px 0;
      padding-top: 16px;
      border-top: 2px solid #ececec;
    }
`;



// WEBPACK FOOTER //
// ./src/incab/common/components/QuestionView/styles.jsx